import { Component, OnInit, TemplateRef, Inject, Input, Output, ViewEncapsulation, ViewChild } from '@angular/core';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { formatDate } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';

import { GestockService } from '../services/gestock.service';



@Component({
  selector: 'app-histoinventaire',
  templateUrl: './histoinventaire.component.html',
  styleUrls: ['./histoinventaire.component.css']
})
export class HistoinventaireComponent implements OnInit {



  samacaabiyoonwii: any;
  porteeUser = "";

  alltypedepenses = [];

  retourClientWS: any;

  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = ['datecreat', 'description', 'categorie', 'montant', 'nomlieudepense', 'debperiode', 'finperiode'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filteredData: any;

  nbrePrdAjust = 0;
  totalEcart = 0;
  totalValeurMonEcart = 0;
  totalValeurReelle = 0;

  boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
  selectedBoutique: string = 'Toutes';



  inventaireDetails = [];

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
  spinnerDialogRef: any;

  @ViewChild('detailInventaireDialog') detailInventaireDialog: TemplateRef<any>;
  detailInventaireDialogRef: any;


  sourceBoutique: any;
  destinationBoutique: any;

  datedeb: any;
  datefin: any;

  inventaireYi = [];

  constructor(private dialog: MatDialog, private configServer: GestockService) {
  }


  ngOnInit(): void {
    this.datedeb = new Date();
    this.datefin = new Date();
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.porteeUser = sessionStorage.getItem("portee");
    this.getAllPoints();
  }

  envoyerTransfert() {
/*    const transfert = {
      source: this.sourceBoutique.id,
      destination: this.destinationBoutique.id,
      articles: this.articles
        .filter(a => a.qteTransfert > 0)
        .map(a => ({ id: a.id, qte: a.qteTransfert }))
    };
*/  }



  getAllPoints() {

    this.configServer.getAllPoints(this.samacaabiyoonwii).then((retourbi) => {
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;
      if (statutreq == 1) {
        console.log("Done");
        this.boutiques = this.retourClientWS.data;
        if (this.boutiques.length == 1)
          this.selectedBoutique = this.boutiques[0].idPoint;
        this.getAllInventaires();
      }
      else {
        console.log("Failed");
      }
    });
  }

  onBoutiqueChange(): void {
  }


  getDateFormatFrench(datebi) {
    if (datebi != undefined) {
      let datebiDoug = new Date(datebi);
      let weerwi = datebiDoug.toLocaleString('fr-FR', { month: 'long' });
      let jourBi = datebiDoug.getDate();
      let anneeBi = datebiDoug.getFullYear();
      return jourBi + " " + weerwi + " " + anneeBi;
    } else
      return "";
  }



  getAllInventaires() {
    console.log(this.datedeb, this.datefin);
    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

    //this.openSpinnerDialog() ;
    this.configServer.getAllInventaires(this.samacaabiyoonwii, this.selectedBoutique, debut, fin).then(async (retourbi) => {
      //this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;

      if (statutreq == 1) {
        this.inventaireYi = this.retourClientWS.data;

        // Calculer la valeur totale pour chaque inventaire
        for (let inv of this.inventaireYi) {
          inv.valeurReelleTotale = 0; // Initialisation
          try {
            const detailRet = await this.configServer.getDetailInventaire(this.samacaabiyoonwii, inv.id);
            if (detailRet && detailRet.statutreq == 1) {
              let details = detailRet.data;
              let total = 0;
              for (let item of details) {
                const qtePhys = Number(item.physique) || 0;
                const cmup = Number(item.cmup) || 0;
                total += (qtePhys * cmup);
              }
              inv.valeurReelleTotale = total;
            }
          } catch (error) {
            console.error("Erreur lors de la récupération des détails de l'inventaire", error);
          }
        }

        console.log("Done");
      }
      else {
        console.log("Failed");
      }
    });
  }

  getMontantFormatee(montant) {
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd;
  }

  getDetailInventaire(benInventaire) {
    let idInventaire = benInventaire.id;
    this.openSpinnerDialog();
    this.configServer.getDetailInventaire(this.samacaabiyoonwii, idInventaire).then((retourbi) => {
      this.closeSpinnerDialog();
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;

      if (statutreq == 1) {
        this.inventaireDetails = this.retourClientWS.data;
        this.getChiffreGlobaux();
        this.opendetailInventaireDialog()
        console.log("Done");
      }
      else {
        console.log("Failed");
      }
    });
  }


  getChiffreGlobaux() {

    this.nbrePrdAjust = 0;
    this.totalEcart = 0;
    this.totalValeurMonEcart = 0;
    this.totalValeurReelle = 0;

    for (var i = 0; i < this.inventaireDetails.length; i++) {

      const lArtticle = this.inventaireDetails[i];
      const ecart = Number(lArtticle.ecart);

      if (ecart != 0) {
        this.nbrePrdAjust++;
        this.totalEcart += ecart;
        this.totalValeurMonEcart += Number(lArtticle.valeurEcart);
      }

      const qtePhys = Number(lArtticle.physique) || 0;
      const cmup = Number(lArtticle.cmup) || 0;
      this.totalValeurReelle += (qtePhys * cmup);


    }
  }

  getDepotAffiche(nomdepot) {
    if (nomdepot == "all")
      return "Tous Les Dépôts";
    else
      return nomdepot;
  }

  opendetailInventaireDialog() {
    this.detailInventaireDialogRef = this.dialog.open(this.detailInventaireDialog, {
      height: 'auto', // or use 'auto'
      maxHeight: '90vh',
    });
  }

  closedetailInventaireDialog() {
    this.detailInventaireDialogRef.close();
  }

  exportToExcel() {
    if (!this.inventaireDetails || this.inventaireDetails.length === 0) {
      return;
    }

    const dataToExport = this.inventaireDetails.map(item => ({
      'REF': item.code,
      'Produit': item.produit,
      'Dépôt': item.depot,
      'Stock Système': item.stockSysteme,
      'Physique': item.physique,
      'Écart': item.ecart,
      'Valeur Écart (FCFA)': item.valeurEcart,
      'Observation': item.observation
      // Note : si vous souhaitez ajouter le cmup, décommentez la ligne ci-dessous
      // 'CMUP': item.cmup
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Details_Inventaire');

    const fileName = `Export_Inventaire_${new Date().getTime()}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}
